module.exports = __webpack_public_path__ + "img/pos.785317f7.png";